import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-2_hl2wbv.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-3_a0viqj.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image_gfifhe.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">
        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 mt-2 md:mb-6 text-[#152C24]">SERVICE PROVIDER</h1>
      
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281649/image-1_revhhh.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />
        <div className="flex-1">
          <section className="bg-white p-6">
            <h2 className="text-[32px] font-bold  mb-6 text-[#152C24]">
              <strong className="font-bold text-black">SERVICE PROVIDERS: </strong>
              What are the benefits?
            </h2>

            <h2 className="font-bold text-[32px] text-black mb-6">
              A service provider using the Farmnet App—whether they’re offering inputs (like seeds or fertilizers), agricultural advice, logistics, credit, or machinery—can gain several key benefits.
            </h2>

            <div className="md:space-y-10 text-[32px] text-[#152C24] mt-10">
              <div>
                <strong>1. Access to a Large Farmer Network</strong>
                <ul className="list-disc  md:pl-12 mt-2 text-black text-[32px]">
                  <li>Direct access to a verified base of farmers in need of services.</li>
                  <li>Easier to market and promote services (e.g. agro-inputs, machinery, extension services).</li>
                </ul>
              </div>

              <div>
                <strong>2. Digital Marketplace for Services</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Ability to list and offer services (e.g., tractor hire, spraying, soil testing) through the app.</li>
                  <li>Farmers can book or request services directly, increasing business opportunities.</li>
                </ul>
              </div>

              <div>
                <strong>3. Streamlined Communication</strong>
                <ul className="list-disc md:pl-12  mt-2 text-black text-[32px]">
                  <li>Engage directly with farmers through the platform.</li>
                  <li>Share updates, offers, or recommendations in-app (like SMS or push notifications).</li>
                </ul>
              </div>

              <div>
                <strong>4. Data-Driven Insights</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Access to farmer activity and crop data (with consent) to better tailor services.</li>
                  <li>Understand regional demand trends and seasonal needs.</li>
                </ul>
              </div>

              <div>
                <strong>5. Easier Payment & Invoicing</strong>
                <ul className="list-disc md:pl-12  mt-2 text-black text-[32px]">
                  <li>Collect payments digitally (mobile money, wallet, or integrated banking).</li>
                  <li>Transparent and trackable transactions with automated records.</li>
                </ul>
              </div>

              <div>
                <strong>6. Build Trust and Visibility</strong>
                <ul className="list-disc md:pl-12  mt-2 text-black text-[32px]">
                  <li>Verified profiles and ratings can help service providers build credibility with farmers.</li>
                  <li>Higher visibility in the farming community, especially in remote or underserved areas.</li>
                </ul>
              </div>

              <div>
                <strong>7. Partnership with Other Ecosystem Players</strong>
                <ul className="list-disc md:pl-12  mt-2 text-black text-[32px]">
                  <li>Collaborate with NGOs, government programs, or agribusinesses connected through Farmnet.</li>
                  <li>Be part of projects offering subsidized services or support programs to farmers.</li>
                </ul>
              </div>

              <div>
                <strong>8. Reduced Operational Costs</strong>
                <ul className="list-disc md:pl-12  mt-2 text-black text-[32px]">
                  <li>Saves time and money by digitizing bookings, outreach, and logistics.</li>
                  <li>Easier coordination of service delivery (e.g., knowing when and where farmers need help).</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Solutions2;
